/**
 * @param {string} selector
 */
export const $ = (selector) => document.querySelector(selector);

// Media query string for the reduced-motion preference. Shared so GSAP's
// matchMedia() and one-off JS gates (Lenis, click handlers) stay in sync.
export const REDUCED_MOTION_MQ = '(prefers-reduced-motion: reduce)';

// Live check — read at call time so it reflects the current OS setting.
export const prefersReducedMotion = () => matchMedia(REDUCED_MOTION_MQ).matches;
